import React from 'react';
import { Typography } from '@mui/material';

export const AuthPageTitle: React.FC<{ children: React.ReactNode }> = (props) => {
    return (
        <Typography variant="h2" gutterBottom sx={{marginBottom: "1rem"}}>{props.children}</Typography>
    );
};
